import { a, list, p, richP, t } from "./legal-types";
export const TERMS = {
    title: "Terms of Service",
    lastUpdated: "November 2026",
    sections: [
        {
            title: "1. Agreement to Terms",
            blocks: [
                p("By accessing or using Agent Todo, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access the service."),
                p('Agent Todo is operated by SapientsAI LLC, a Massachusetts limited liability company ("we", "our", or "us"). These terms are an agreement between you and SapientsAI LLC.'),
            ],
        },
        {
            title: "2. Description of Service",
            blocks: [
                p("Agent Todo provides a task management platform that integrates with various task providers (Microsoft Todo, Google Tasks, Todoist) and enables AI assistants to interact with your tasks through the Model Context Protocol (MCP)."),
            ],
        },
        {
            title: "3. User Accounts",
            blocks: [
                p("To use our service, you must:"),
                list("Create an account with accurate information", "Maintain the security of your account credentials", "Promptly notify us of any unauthorized use", "Be responsible for all activities under your account"),
            ],
        },
        {
            title: "4. Acceptable Use",
            blocks: [
                p("You agree not to:"),
                list("Use the service for any illegal or unauthorized purpose", "Attempt to bypass any security features", "Interfere with or disrupt the service", "Transmit viruses or malicious code", "Violate any applicable laws or regulations"),
            ],
        },
        {
            title: "5. Subscription Plans and Pricing",
            blocks: [
                richP(t("Agent Todo offers multiple subscription tiers, including a free tier and paid plans. Paid plans provide additional features such as more provider connections, email-to-task processing, and digest notifications. Current pricing and feature details are available on our "), a("Pricing Page", "/pricing"), t(".")),
                list("Free tier: Limited to 1 total provider connection, with read and write access to tasks; scheduled digests and email-to-task are not included", "Paid tiers: Additional provider connections, full read/write access, and premium features as described on the pricing page", "We reserve the right to modify pricing with 30 days advance notice to existing subscribers"),
            ],
        },
        {
            title: "6. Billing and Payment",
            blocks: [
                p("For paid subscription plans:"),
                list("Subscriptions are billed on a monthly recurring basis starting from the date of initial purchase", "Payment is processed securely through Stripe. We do not store your full credit card details on our servers", "You authorize us to charge your payment method on file for recurring subscription fees", "If a payment fails, we will notify you by email and may retry the charge. Your account features may be restricted until payment is resolved", "You are responsible for keeping your payment information current. You can update your payment method at any time through the Stripe billing portal accessible from your account settings"),
            ],
        },
        {
            title: "7. Refunds and Cancellation",
            blocks: [
                p("You may cancel your subscription at any time through your account settings or the Stripe billing portal."),
                {
                    kind: "list",
                    items: [
                        [
                            t("Upon cancellation, your subscription remains active until the end of the current billing period. You will not be charged for subsequent periods"),
                        ],
                        [t("No partial refunds are provided for unused time within a billing period")],
                        [
                            t("After your paid subscription ends, your account will be downgraded to the free tier. You will retain access to your data but may lose access to premium features and additional provider connections"),
                        ],
                        [
                            t("If you believe you were charged in error, please contact us at "),
                            a("support@agent-todo.com", "mailto:support@agent-todo.com"),
                            t(" within 30 days of the charge. We will review refund requests on a case-by-case basis"),
                        ],
                    ],
                },
            ],
        },
        {
            title: "8. Auto-Renewal",
            blocks: [
                p("All paid subscriptions automatically renew at the end of each billing period unless you cancel before the renewal date. You will receive a payment confirmation email after each successful renewal. You can manage your subscription and cancel auto-renewal at any time from your account settings."),
            ],
        },
        {
            title: "9. Third-Party Services",
            blocks: [
                p("Our service integrates with third-party task providers. Your use of these services is subject to their respective terms of service. We are not responsible for the availability or functionality of third-party services."),
            ],
        },
        {
            title: "10. Intellectual Property",
            blocks: [
                p("The service and its original content, features, and functionality are owned by Agent Todo and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws."),
            ],
        },
        {
            title: "11. Privacy",
            blocks: [
                richP(t("Your use of our service is also governed by our "), a("Privacy Policy", "/privacy"), t(". Please review our Privacy Policy, which explains how we collect, use, and protect your information.")),
            ],
        },
        {
            title: "12. Termination",
            blocks: [
                p("We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms."),
            ],
        },
        {
            title: "13. Disclaimer",
            blocks: [
                p('The service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, and hereby disclaim all warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, or non-infringement.'),
            ],
        },
        {
            title: "14. Limitation of Liability",
            blocks: [
                p("In no event shall Agent Todo, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses."),
            ],
        },
        {
            title: "15. Indemnification",
            blocks: [
                p("You agree to defend, indemnify, and hold harmless Agent Todo and its licensees and licensors from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the service or violation of these Terms."),
            ],
        },
        {
            title: "16. Governing Law",
            blocks: [
                p("These Terms shall be governed and construed in accordance with the laws of the United States, without regard to its conflict of law provisions."),
            ],
        },
        {
            title: "17. Changes to Terms",
            blocks: [
                p("We reserve the right to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect."),
            ],
        },
        {
            title: "18. Contact Information",
            blocks: [
                richP(t("If you have any questions about these Terms, please contact us at "), a("legal@agent-todo.com", "mailto:legal@agent-todo.com")),
            ],
        },
    ],
};
